<template>
  <div :class="classes">
    <div class="wf-text-center">
      <img class="wf-w-48 wf-inline-block" src="https://storage.googleapis.com/wfs/images/logo-01.png" alt="">  
    </div>
    <div class="wf-flex wf-w-full wf-justify-center wf-mt-4">
      <div class="wf-w-0 wf-flex-1"></div>
      <nav class="wf-flex-2">
        <ul class="wf-justify-center wf-flex wf-items-baseline" :class="containerNavLinkClasses">
          <template v-for="(navLink, index) in navLinks">
            <HeaderNavLink
              :key="index"
              :navLink="navLink"
              :classes="navLinkClasses"
              :styles="navLinkStyles"
              :subMenuClasses="subMenuClasses"
              :subMenuContainerClasses="subMenuContainerClasses"
              :subMenuContainerStyles="subMenuContainerStyles"
              :subMenuStyles="subMenuStyles"
              :megaMenuClasses="megaMenuClasses"
              :megaMenuFullWidth="megaMenuFullWidth"
              :megaMenuStyles="megaMenuStyles"
              :megaMenuContainerClasses="megaMenuContainerClasses"
              :megaMenuContainerStyles="megaMenuContainerStyles"
              :megaMenuTitleClasses="megaMenuTitleClasses"
              :megaMenuTitleStyles="megaMenuTitleStyles"
            />
          </template>
        </ul>
      </nav>
      <div class="wf-w-0 wf-flex-1 wf-text-right">
        <div class="wf-inline-block" :class="ctaClasses" :style="ctaStyles" v-show="hasCta">
          <div v-text="ctaText"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderContract from '../../contracts/HeaderContract'
  export default HeaderContract.extend({})
</script>